export type IllustrationProps = React.SVGProps<SVGSVGElement>;
import { lazy } from "react";

// Define a dictionary where each key corresponds to an illustration
const Illustrations = {
  Ai: lazy(() => import("./Ai")),
  Bread: lazy(() => import("./Bread")),
  Brocoli: lazy(() => import("./Brocoli")),
  ChefHat: lazy(() => import("./ChefHat")),
  Cocktail: lazy(() => import("./Cocktail")),
  Coffee: lazy(() => import("./Coffee")),
  Drink01: lazy(() => import("./Drink-01")),
  Drink02: lazy(() => import("./Drink-02")),
  Drink03: lazy(() => import("./Drink-03")),
  Error: lazy(() => import("./Error")),
  FinishedPlate: lazy(() => import("./FinishedPlate")),
  FoodDetails: lazy(() => import("./FoodDetails")),
  Fork: lazy(() => import("./Fork")),
  IceCream: lazy(() => import("./IceCream")),
  Laptop: lazy(() => import("./Laptop")),
  Loading: lazy(() => import("./Loading")),
  LoyaltyCard: lazy(() => import("./LoyaltyCard")),
  Note: lazy(() => import("./Note")),
  Oyster: lazy(() => import("./Oyster")),
  Pastries: lazy(() => import("./Pastries")),
  Plate: lazy(() => import("./Plate")),
  PaperMenu: lazy(() => import("./PaperMenu")),
  Payment: lazy(() => import("./Payment")),
  Reserve: lazy(() => import("./Reserve")),
  Service: lazy(() => import("./Service")),
  ServiceWine: lazy(() => import("./ServiceWine")),
  Sharing: lazy(() => import("./Sharing")),
  Stars: lazy(() => import("./Stars")),
  Table: lazy(() => import("./Table")),
  Toast: lazy(() => import("./Toast")),
};

export default Illustrations;
